// Payment notifications open the payment-request drawer by default. POS terminal payments have no
// request, so they map to their own type and open the transaction drawer instead.
const PAYMENT_REQUEST_TYPES = ["AllPayments", "CustomerPayments", "MyRequests"];

// What a notification opens, resolved from (type, primaryEntityId) first — the structured id is the
// source of truth. Returns an intent the click handler acts on: a drawer opened over the current
// page, or a plain "navigate" fallback. Add kinds here as more entities become openable.
export const notificationTarget = ({ type, primaryEntityId, url } = {}) => {
  if (primaryEntityId && type === "TerminalPayments") {
    // POS terminal payments are always card.
    return { kind: "transaction", id: primaryEntityId, paymentMethodKey: "card" };
  }

  if (primaryEntityId && type === "Payouts") {
    return { kind: "payout", id: primaryEntityId };
  }

  if (primaryEntityId && type === "NoteTagged") {
    return { kind: "note", id: primaryEntityId };
  }

  if (primaryEntityId && type === "TaskAssigned") {
    return { kind: "task", id: primaryEntityId };
  }

  if (primaryEntityId && PAYMENT_REQUEST_TYPES.includes(type)) {
    return { kind: "paymentRequest", id: primaryEntityId };
  }

  if (url) {
    return { kind: "navigate", url };
  }

  return null;
};
